export class LayerModule {
    constructor(terrainView, layerInfo) {
        this.terrainView = terrainView;
        this.layerInfo = layerInfo;
        this.oviewLayer = null;        
    }

    async OpenLayer(callback) {
        console.log("open");
    }

    async RemoveLayer() {        
        if (this.oviewLayer) {
            // 有參考的圖層到都加進去
            let index = window.gMainMap.TerrainView.openedLayerStack.indexOf(this.oviewLayer.name || this.oviewLayer.layername);
            if (index >= 0) {
                window.gMainMap.TerrainView.openedLayerStack.splice(index, 1);                
            }
            //再搜尋一次，確定是否為最後一個圖層
            index = window.gMainMap.TerrainView.openedLayerStack.indexOf(this.oviewLayer.name || this.oviewLayer.layername);
            if (index < 0) {
                if (IsClass(this.oviewLayer, ov.TerrainOverlay))
                    this.terrainView.removeTerrainOverlay(this.oviewLayer);
                else
                    this.terrainView.removeLayer(this.oviewLayer);
                delete this.oviewLayer;
            }
        }
    }

    async SetOpacity(v) {
        v = parseFloat(v);
        if (isNaN(v)) {
            return;
        }
        if (v > 1.0) {
            v = 1.0;
        }
        if (v < 0) {
            v = 0;
        }

        if (this.oviewLayer) {
            if (IsClass(this.oviewLayer, ov.TerrainOverlay))
                this.oviewLayer.opacity = v;
            else {
                this.oviewLayer.setOpacity(v);
            }
        }
    }    

    async Goto() {
        if (this.layerInfo.Goto) {
            this.terrainView.gotoCamera(
                new window.ov.Camera(
                    new Geo3DPoint(this.layerInfo.Goto.Pos),
                    new Geo3DPoint(this.layerInfo.Goto.V),
                    new Geo3DPoint(this.layerInfo.Goto.Up),
                ), true);
        } else if (this.oviewLayer && this.oviewLayer.goto) {
            this.oviewLayer.goto();
        }
    }
}
